import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Header from 'components/Header';
import Loading from 'components/Loading';
import Footer from 'components/Footer';
import styles from './index.less';
import { isEmpty } from 'utils/index';
import { getShowTopBar } from '../../../utils/getValue';
const languageMap = {
  'zh-cn': {
    boardingGate: '登机口',
  },
  en: {
    boardingGate: 'boardingGate',
  },
};

@connect(({ meal, loading }) => ({
  mealList: meal.mealList,
  loading: loading.effects['meal/queryNetworkDetail'],
}))
class MealNetwork extends Component {
  componentDidMount() {
    const { sid, language, netwrokType, yuyueCode, projectId } = this.props.location.query;
    this.props.dispatch({
      type: 'meal/queryNetworkDetail',
      payload: {
        sid,
        language,
        netwrokType,
        yuyueCode,
        projectId,
      },
    });
  }

  toMeal(id) {
    const { language } = this.props.location.query;
    router.push({
      pathname: '/meal/detail',
      query: {
        id,
        language,
      },
    });
  }

  render() {
    const { mealList, loading } = this.props;
    const { name } = this.props.location.query;
    const lg = this.props.location.query.language || localStorage.getItem('language') || 'zh-cn';
    const showTopBar = getShowTopBar();
    const className = showTopBar ? 'mainContent' : 'notHeader';
    return (
      <Fragment>
        <Header title={name} />

        <Loading loading={loading}>
          <div className={className}>
            {mealList &&
              mealList.map((item) => {
                return (
                  <div className={styles.block} onClick={() => this.toMeal(item.id)} key={item.id}>
                    <div className={styles.picWrap}>
                      <img className={styles.pic} src={`${item.defultImage}?w=670&h=210`} alt="" />
                      {/* 暂时隐藏评分 */}
                      {/* <div className={styles.score}>
                        <img
                          className={styles.pic}
                          src={require('images/home_label_grade@2x.png')}
                          alt=""
                        />
                        <span>{item.star}</span>
                      </div> */}
                    </div>

                    <div className={styles.airport}>{item.name}</div>
                    <div className={styles.terminal}>
                      {item.terminal}
                      {isEmpty(item.boardingGate) ? null : (
                        <Fragment>
                          , {languageMap[lg].boardingGate}:{item.boardingGate}
                        </Fragment>
                      )}
                    </div>
                    {/* <div className={styles.type}>{item.type},{item.inspection}</div> */}
                  </div>
                );
              })}
          </div>
          <Footer />
        </Loading>
      </Fragment>
    );
  }
}

export default MealNetwork;
